var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymenttwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "#FEB4C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78235 25.6327H6.47656V15H8.78235V25.6327ZM14.5363 15H12.2805C12.2805 16.9567 11.4305 18.7526 9.94839 19.9276L9.05469 20.6359L12.5175 25.6331H15.3646L12.1783 21.0349C13.6887 19.4433 14.5363 17.3019 14.5363 15ZM18.2167 25.6298H16.0392V15.002H18.2167V25.6298ZM24.7974 18.2774V18.7477C24.2099 18.3235 23.5007 18.0742 22.7358 18.0742C20.7114 18.0742 19.0703 19.811 19.0703 21.9534C19.0703 24.0958 20.7114 25.8326 22.7358 25.8326C23.5007 25.8326 24.2099 25.5833 24.7974 25.1592V25.6291H26.8773V18.2774H24.7974ZM24.7926 21.9538C24.7926 22.9984 23.9488 23.8453 22.908 23.8453C21.8672 23.8453 21.0234 22.9984 21.0234 21.9538C21.0234 20.9092 21.8672 20.0625 22.908 20.0625C23.9488 20.0625 24.7926 20.9092 24.7926 21.9538ZM46.735 18.7477V18.2774H48.8148V25.6291H46.735V25.1592C46.1474 25.5833 45.4383 25.8326 44.6733 25.8326C42.6489 25.8326 41.0078 24.0958 41.0078 21.9534C41.0078 19.811 42.6489 18.0742 44.6733 18.0742C45.4383 18.0742 46.1474 18.3235 46.735 18.7477ZM44.8455 23.8453C45.8863 23.8453 46.73 22.9984 46.73 21.9538C46.73 20.9092 45.8863 20.0625 44.8455 20.0625C43.8046 20.0625 42.9609 20.9092 42.9609 21.9538C42.9609 22.9984 43.8046 23.8453 44.8455 23.8453ZM49.7188 24.4038C49.7188 23.6408 50.3031 23.0225 51.0238 23.0225C51.7446 23.0225 52.329 23.6408 52.329 24.4038C52.329 25.1665 51.7446 25.785 51.0238 25.785C50.3031 25.785 49.7188 25.1665 49.7188 24.4038ZM37.3152 18.0801C36.4844 18.0801 35.6981 18.3531 35.1724 19.1062V18.2782H33.1016V25.6295H35.1978V21.7661C35.1978 20.6482 35.9062 20.1008 36.7591 20.1008C37.6732 20.1008 38.1987 20.6786 38.1987 21.7509V25.6295H40.276V20.9544C40.276 19.2436 38.9907 18.0801 37.3152 18.0801ZM30.0903 18.2783V19.2358C30.5073 18.6615 31.2841 18.2787 32.1287 18.2787V20.418C32.1248 20.4179 32.1209 20.4177 32.1171 20.4175L32.11 20.4171L32.104 20.417C31.2811 20.417 30.0951 21.0395 30.0951 22.1975V25.6299H27.9609V18.2783H30.0903Z",
    fill: "#17120F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymenttwo);
export default __webpack_public_path__ + "static/media/Paymenttwo.6de2a1c400fc003c4a59b2ece42384ed.svg";
export { ForwardRef as ReactComponent };